<template>
  <div>
    <div class="vx-row">
      <vx-card title no-shadow card-border>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <span class="font-medium text-lg leading-none">{{
                $t("inventory.label.MrnCarton")
              }}</span>
            </div>
            <vs-divider />
          </div>
        </div>
        <form>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <small class="date-label font-semibold">{{ $t("inventory.label.Type") }}</small>
              <v-select
                label="typeData"
                v-model="mrn.typeData"
                :options="typeData"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2 font-semibold"
              >
                <template v-slot:option="option">{{
                  option.typeData
                }}</template>
              </v-select>
              <!-- <vs-td :data="getDate(contract.requestedDate)">{{ getDate(contract.requestedDate) }}</vs-td> -->
              <vs-input
                :label="$t('inventory.label.CartonNo')"
                class="w-full mb-2 font-semibold"
                v-model="mrn.cartoonNumber"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <small class="date-label font-semibold">{{ $t("inventory.label.MrnId") }}</small>
              <v-select
                label="itemDescription"
                v-model="mrn.itemDescription"
                :options="mrnIds"
                :reduce="(obj) => obj.id"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2 font-semibold"
                @input="getcartoonNumbers"
              >
                <template v-slot:option="option"
                  >{{ option.mrnId }} -- {{ option.itemDescription }}
                </template>
              </v-select>
            </div>
          </div>
          <div class="vx-row float-right my-2">
            <div class="vx-col w-full">
              <vs-button class="mr-3 mb-2" @click="createContract">{{
                $t("inventory.label.Submit")
              }}</vs-button>
              <vs-button
                color="warning"
                type="border"
                class="mb-2"
                @click="resetForm"
                >{{ $t("inventory.label.Cancel") }}
              </vs-button>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate/dist/vee-validate";
// import NProgress from 'nprogress/nprogress.js'
import { getMrnTemplateId, getcartoonNumbers } from "@/http/inventory";

import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";

const cartonEmptyObj = {
  type: "mrn",
  mrnId: "",
  cartoonNumber: "",
  locale: "en",
  movedDate: "",
};

export default {
  data() {
    return {
      carton: cartonEmptyObj,
      errorMessage: "",
      typeData: ["mrn"],
      itemsaleIds: {},
      mrnIds: [],
      requestedDate: "",
      contracts: {},
      itemDescription: "",
      mrnId: "",
      mrn: {},
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  // mounted() {
  //     this.createContract()
  // },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    async getMrnTemplateId() {
      try {
        const response = await getMrnTemplateId();
        this.mrn = response.data;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },

    async getcartoonNumbers() {
      try {
        const cartoons = await getcartoonNumbers(this.id);
        this.cartoon = cartoons.data;
        // this.mrn.itemDescription = response.data.mrnIds.itemDescription;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    async createContract() {
      this.carton = {
        type: "mrn",
        mrnId: "",
        cartoonNumber: "",
        locale: "en",
        movedDate: "",
      };
      try {
        const resp = await saveCarton(this.carton);
        if (resp.data.resourceId && resp.data.resourceId) {
          this.$router.push("/setup");
          this.resetForm();
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating contract:", e);
      }
    },
    resetForm() {
      this.contract = contractEmptyObj;
      this.contract.subscriptionPeriod = "";
      this.contract.subscriptionType = "";
      this.contract.units = "";
    },
  },
  watch: {
    mrn(value) {
      this.mrnIds = value.mrnIds;
    },
  },
  created() {
    this.getMrnTemplateId();
  },
};
</script>
